import logs from "./logs";

export const offerwall = {
    logs,
};

export default offerwall;
